"use strict";

import angular from "angular";
import template from "./select-projection-menu.component.html";
import "./select-projection-menu.component.scss";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { PublicCompany } from "../../../presentation/services/PublicCompany/PublicCompany";

export class SelectProjectionMenuComponent {
    constructor($state) {
        this.$state = $state;
    }

    $onInit() {
        this.hasPermissionCompanyModel =
            PublicCompany.hasPermissionModelToModify(
                this.$state.params.id,
                new UserDataAdapter().user()
            );
    }

    onOpenPopOverDialogCreateProjection(ev) {
        this.toggleProjectionPopOver = !this.toggleProjectionPopOver;
        this.openDialogCreateProjection({ $event: ev });
    }

    onRemoveScenario(ev, scenario) {
        this.toggleProjectionPopOver = !this.toggleProjectionPopOver;
        this.removeScenario({ ev, scenarioId: scenario._id });
    }

    onSelectProjectionPopOver(scenario) {
        this.toggleProjectionPopOver = !this.toggleProjectionPopOver;
        this.onSelectProjection({ scenario });
    }

    renameScenario(ev, scenario) {
        this.toggleProjectionPopOver = !this.toggleProjectionPopOver;
        this.onRenameScenario({ ev, scenario });
    }

    isDisabledToEdit(scenario) {
        return scenario?.options?.editMode === false;
    }
}

SelectProjectionMenuComponent.$inject = ["$state"];

const name = "selectProjectionMenuComponent";
const def = {
    controller: SelectProjectionMenuComponent,
    template,
    bindings: {
        current: "<",
        onSelectProjection: "&",
        removeScenario: "&",
        onRenameScenario: "&",
        openDialogCreateProjection: "&",
        scenarioType: "<",
        titleButton: "@"
    }
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
